export const formatDateTime = (value?: string) => {
    if (!value) return '';
    return new Date(value).toLocaleString('ja-JP');
};